import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NumberUtils } from '../utils/number.util';

@Pipe({
  name: 'abbreviateAmount'
})
export class AbbreviateAmountPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: any, args?: any): any {
    let result: string;
    let formatted = this.decimalPipe.transform(value, '1.2-2');
    let parsed = this.parse(formatted);
    if (parsed < 1000) {
      result = formatted;
    } else {
      let aux = value / 1000.0;
      formatted = this.decimalPipe.transform(aux, '1.1-1');
      parsed = this.parse(formatted);
      if (parsed < 1000) {
        result = formatted.concat(' K');
      } else {
        aux = value / 1000000.0;
        result = this.decimalPipe.transform(aux, '1.1-1').concat(' M');
      }
    }
    return result;
  }

  /**
   * Converts string to number.
   *
   * @param input
   */
  private parse(input: string) {
    // Obtain the decimal separator
    const decimalSeparator = NumberUtils.getDecimalSeparator();
    // Normalize the number if there's more than one decimal separator in the String
    let pattern = '([' + decimalSeparator + '])(?=.*\\1)';
    let formatted = input.replace(new RegExp(pattern, 'g'), '');
    // Remove anything that is not a number or a decimal separator
    formatted = formatted.replace(new RegExp('[^0-9' + decimalSeparator + ']', 'g'), '');
    return Number(formatted);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pipes/abbreviate-amount.pipe.ts